import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigurationService} from '../../configuration.service';
import {UrlEndpoints} from '../../../definitions/url-endpoints';

@Injectable({
    providedIn: 'root'
})
export class StockTakeZoneResourceService {

    constructor(private http: HttpClient,
                private configuration: ConfigurationService,
                private urlEndpoints: UrlEndpoints) {
    }

    checkZone(zone: string) {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getRegisterZoneStockTake +
            zone)).toPromise();
    }
}
